<template>
  <v-card flat>
    <v-card-text class="subtitle-1 pt-0">
      Name: <b>{{ $store.getters.retrieveUser.username }}</b>
    </v-card-text>

    <v-card-text class="subtitle-1 pt-0">
      Email: <b>{{ $store.getters.retrieveUser.email_address }}</b>
    </v-card-text>

     <v-card-text class="subtitle-1 pt-0">
      Type: <b>{{ $store.getters.retrieveAdmin.account_type }}</b>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "UserInfoCard",
};
</script>

<style>
</style>